module.exports = __webpack_public_path__ + "media/images/e-bilet/arrows__form-1857d168277d29689ce8f80efea99848.png";